var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperlinkBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3593_196151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 0H2.10938C0.946266 0 0 0.946266 0 2.10938V4.21875H24V2.10938C24 0.946266 23.0537 0 21.8906 0ZM3.5625 2.8125C3.17419 2.8125 2.85938 2.49769 2.85938 2.10938C2.85938 1.72106 3.17419 1.40625 3.5625 1.40625C3.95081 1.40625 4.26562 1.72106 4.26562 2.10938C4.26562 2.49769 3.95081 2.8125 3.5625 2.8125ZM6.375 2.8125C5.98669 2.8125 5.67188 2.49769 5.67188 2.10938C5.67188 1.72106 5.98669 1.40625 6.375 1.40625C6.76331 1.40625 7.07812 1.72106 7.07812 2.10938C7.07812 2.49769 6.76331 2.8125 6.375 2.8125ZM9.1875 2.8125C8.79919 2.8125 8.48438 2.49769 8.48438 2.10938C8.48438 1.72106 8.79919 1.40625 9.1875 1.40625C9.57581 1.40625 9.89062 1.72106 9.89062 2.10938C9.89062 2.49769 9.57581 2.8125 9.1875 2.8125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.625V16.1719C0 17.335 0.946266 18.2812 2.10938 18.2812H15.9844V12.8906C15.9844 12.7182 16.0056 12.5459 16.0475 12.3787L16.9849 8.62903C17.22 7.6883 18.0615 7.03125 19.0312 7.03125C20.001 7.03125 20.8425 7.6883 21.0776 8.62908L22.0151 12.379C22.0569 12.5459 22.0781 12.7182 22.0781 12.8906V18.2725C23.1537 18.1772 24 17.2718 24 16.1719V5.625H0ZM14.3438 15.4688H3.09375C2.70544 15.4688 2.39062 15.1539 2.39062 14.7656C2.39062 14.3773 2.70544 14.0625 3.09375 14.0625H14.3438C14.7321 14.0625 15.0469 14.3773 15.0469 14.7656C15.0469 15.1539 14.7321 15.4688 14.3438 15.4688ZM14.3438 12.6562H3.09375C2.70544 12.6562 2.39062 12.3414 2.39062 11.9531C2.39062 11.5648 2.70544 11.25 3.09375 11.25H14.3438C14.7321 11.25 15.0469 11.5648 15.0469 11.9531C15.0469 12.3414 14.7321 12.6562 14.3438 12.6562ZM14.3438 9.84375H3.09375C2.70544 9.84375 2.39062 9.52894 2.39062 9.14062C2.39062 8.75231 2.70544 8.4375 3.09375 8.4375H14.3438C14.7321 8.4375 15.0469 8.75231 15.0469 9.14062C15.0469 9.52894 14.7321 9.84375 14.3438 9.84375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3906 13.5938H20.6719V19.7812H17.3906V13.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5176 12.1875L19.7133 8.97009C19.635 8.65711 19.3538 8.4375 19.0311 8.4375C18.7085 8.4375 18.4272 8.65711 18.349 8.97009L17.5447 12.1875H20.5176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3906 21.1875V22.3594C17.3906 23.2641 18.1266 24 19.0312 24C19.9359 24 20.6719 23.2641 20.6719 22.3594V21.1875H17.3906Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3593_196151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkBlog);
export default __webpack_public_path__ + "static/media/hyperlink-blog.69eda857b4767e2f7cd70e7accdfe744.svg";
export { ForwardRef as ReactComponent };